const navIcon = document.querySelector('.nav-icon');
const mobileMenu = document.querySelector('.menu');
const articleLinks = [...document.querySelectorAll('.menu__articles-list .menu__articles-list-item')];
const menu = (function() {
    function _toggleNav() {
        navIcon.classList.toggle('open');
        mobileMenu.classList.toggle('show');
    }
    function init() {
        navIcon.addEventListener('click', _toggleNav);
        articleLinks.forEach(link => {
            link.addEventListener('click', _toggleNav);
        });
    }
    return {
        init: init
    };
})();
export default menu;
